export default __webpack_public_path__ + "static/media/Belt of the Black Pharaoh.ae858721.jpg";